import { ECM_DEFINITIONS } from '#apps/client-web/features/audit-form-ecms/constants';

import { type AuditEcmsForm } from '#packages/data-collection/models/audit-ecms-form';

import { type EditAuditFormEcmsData } from './types';

export const fromFormData = (
  formData: EditAuditFormEcmsData,
): AuditEcmsForm => ({
  type: 'ecms',
  ecms: formData.ecms,
});

export const toFormData = (
  data: AuditEcmsForm | undefined,
): EditAuditFormEcmsData => ({
  ecms: ECM_DEFINITIONS.map((ecm) => {
    const existingEcm = data?.ecms?.find((e) => e.id === ecm.id);
    return {
      id: ecm.id,
      criteria: ecm.criteria.map((criterion) => {
        const existing = existingEcm?.criteria?.find(
          (c) => c.id === criterion.id,
        );
        return {
          id: criterion.id,
          answer: existing?.answer,
          notes: existing?.notes,
        };
      }),
    };
  }),
});
